export class InputCost {
  id: number;
  plannedQuantity: number;
  plannedValue: number;
  appropriateQuantity: number;
  appropriateValue: number;
  percentageAppropriateQuantityUnderPlannedQuantity: number;
  percentageAppropriateValueUnderPlannedValue: number;
}
